import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Container, OverlayTrigger, Tooltip, Form, Toast,Card } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { formato_rut } from '../../common/Formatos'
import { useLocation, useNavigate } from 'react-router-dom'
import Mensajes from '../mensajes'

const Grilla = ({handleClose,formik,isExtra,isJudi,setIdRespon,setnombreRespon,setShowToast,showToast}) => {

const [show, setShow] = useState(false) 
const [noReasigna, setNoReasigna] = useState(true) 
const [idResp, setIdResp] = useState('') 
const [nombreR, setNombreR] = useState('') 
const [observacion, setObservacion] = useState('') 
const [listaGrilla,setListaGrilla]= useState('') 
const data_reasignar = useSelector((state) => state.ReasignarResponsableReducer)
const { cfg_form28, datosGrilla, respuestaAsignar, tiposNotificaSiniestro, datosGestionCaso} = data_reasignar

const {state}=useLocation()
const queryState=state?.myQueryState && state.myQueryState

const history =useNavigate()

useEffect(()=>{
  if(respuestaAsignar && respuestaAsignar.respuestaAsignar["code"]===1){
    setTimeout(()=> history('/area-gestion-compania',{state:{queryState}}),2000)      
  }
},[respuestaAsignar])

useEffect(()=>{
 if(respuestaAsignar && respuestaAsignar.respuestaAsignar["code"] === 1){
   setTimeout(()=> setNoReasigna(true),2000)
 }
},[respuestaAsignar])
useEffect(()=>{
    setIdRespon(idResp)
},[idResp])
useEffect(()=>{
    setnombreRespon(nombreR)
},[nombreR])
 useEffect(()=>{
  setListaGrilla(datosGrilla && datosGrilla.datosGrilla)
 },[datosGrilla])
 useEffect(()=>{
  setListaGrilla('')
 },[])
 const obtenerColumnas = () => {
  return [
    
    
    {
      dataField: 'idResponsable',
      text:cfg_form28 ? cfg_form28.cfg_form28[
        'reasignaresponsable-grilla-id'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form28 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'nombre',
      text: cfg_form28 ? cfg_form28.cfg_form28[
        'reasignaresponsable-grilla-nombre'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form28 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: isExtra && !isJudi?('cntCasosCerEJ'):isJudi && !isExtra?('cntCasosCerJU'):('cntCasosCerrados'),
      text: cfg_form28 ? cfg_form28.cfg_form28[
        'reasignaresponsable-grilla-casoscerrados'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form28 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: isExtra && !isJudi?('cntCasosAbiEJ'):isJudi && !isExtra?('cntCasosAbiJU'):('cntCasosAbiertos') ,
      text:cfg_form28 ? cfg_form28.cfg_form28[
        'reasignaresponsable-grilla-casospend'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
           {cfg_form28 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: isExtra && !isJudi?('totalCasosEJ'):isJudi && !isExtra?('totalCasosJU'):('totalCasos'),
      text: cfg_form28 ?cfg_form28.cfg_form28[
        'reasignaresponsable-grilla-totalcasos'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form28 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
    {
      dataField: 'tpoCierrePromedio',
      text: cfg_form28 ? cfg_form28.cfg_form28[
        'reasignaresponsable-grilla-tpocierreprom'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
           {cfg_form28 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    {
      dataField:  isExtra && !isJudi?('montoPromRDEJ'):isJudi && !isExtra?('montoPromRDJU'):('montoRecuperoPromedio'),
      text: cfg_form28 ? cfg_form28.cfg_form28[
        'reasignaresponsable-grilla-mtorecuprom'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
           {cfg_form28 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    {
        dataField: 'opciones',
        text: '',
        isDummyField: true,
        headerStyle: (colum, colIndex) => {
          return {
            width: '40%',
            textAlign: 'center',
            verticalAlign: 'center',
            backgroundColor: '#728bb0',
            color: 'white'
          }
        },
        style: { textAlign: 'center', verticalAlign: 'middle' },
        formatter: (cell, row) => (
          
         <div>
             <OverlayTrigger
              overlay={<Tooltip id='tooltip-disabled'>Reasignar </Tooltip>}
            >
              <Button
                type='button'
                variant='reasignar me-md-2'
                size='sm'
               onClick={()=>handleReasignar(row)}
              >
               {
                          cfg_form28.cfg_form28[
                            'reasignaresponsable-btn-reasignar'
                          ]
                        }
              </Button>
            </OverlayTrigger>
            
            
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      }
   
  ]
}
const handleReasignar=(row)=>{
    setNoReasigna(false)
    setIdResp(row.idResponsable)
    setNombreR(row.nombre)
}
const handleCloseToast = () => {
  setShowToast(false);
}
  return (
    <>
     <style type='text/css'>
     {`
  
  .btn-reasignar {
    background-color: #C14B49;
    color: #FFFFFF;
    width: 80px;
    padding:6px 0px 6px 0px;

  }
  .btn-reasignar:hover{
      background-color: #F6897E;
    color: #FFFFFF;
  }
  .btn-confirmar {
    background-color: #C14B49;
    color: #FFFFFF;
    width: 140px;
    padding:6px 0px 6px 0px;

  }
  .btn-confirmar:hover{
      background-color: #F6897E;
    color: #FFFFFF;
  }
  
  `}
      </style>
     
      {noReasigna ?( 
      <Container>      
        <Row className='mt-2 mb-3'>
            <Col>
              <ToolkitProvider
                  search
                  bootstrap4
                  keyField='Id'
                  data={listaGrilla ? listaGrilla : []}
                  columns={obtenerColumnas()}
                  defaultSorted={[{ dataField: 'Id', order: 'asc' }]}
                  >
                  {(props) => (
                      <div>
                      <BootstrapTable
                          {...props.baseProps}
                          bordered={false}
                          headerWrapperClasses='table-secondary'
                          pagination={paginationFactory({ sizePerPage: 5})}
                          noDataIndication={
                          <div className='text-center'>
                              No hay registros encontrados
                          </div>
                          }
                      />
                      </div>
                  )}
              </ToolkitProvider>
            </Col>
        </Row>
        <Row>
        <hr style={{ color: 'gray', height: '2px', marginTop:'30px'}}></hr>
        </Row>
        <Row>
          <Col className='d-flex align-items-end justify-content-end m-2'>
            <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}   >
                {cfg_form28 && cfg_form28.cfg_form28["reasignaresponsable-btn-cerrar"]}
          </Button>
          </Col>
        </Row>
      </Container>):(
        <>
        <Container>
          <Card >
            <Card.Header className='mt-2 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
              {cfg_form28 ? cfg_form28.cfg_form28['reasignaresponsable-title-confirmar']:''} 
            </Card.Header>
            <Container>
              <Container>
                <Row >
                  <Col md='3'>
                    <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '16px' }} >
                          { cfg_form28.cfg_form28['reasignaresponsable-lbl-idresp']}
                    </Form.Label>{' '}
                    <br />
                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          {formato_rut(idResp && idResp.toString())}
                    </Form.Text>
                  </Col>
                  <Col md='3'>
                    <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '16px' }} >
                      {cfg_form28.cfg_form28['reasignaresponsable-lbl-nombreresp']}
                    </Form.Label>
                    <br />
                    <Form.Text className='mb-3' style={{ fontSize: '14px' }}>{nombreR}</Form.Text>
                  </Col>
                </Row>
                {datosGestionCaso && datosGestionCaso.datosGestionCaso[0].codTipoGestion == 207002 ? (
                <Row>
                  <Col md='4'>
                    <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        Notifica Siniestro con Proceso
                    </Form.Label>
                    <br />
                    <Form.Select
                      className='mt-2'
                      aria-label='Default select example'                         
                      onChange={(e) => {                        
                        formik.handleChange(e)
                      }}
                      name='cbNotificaSiniestro'
                      >
                      <option value={''}>Seleccione...</option>
                      {tiposNotificaSiniestro &&
                        tiposNotificaSiniestro.tiposNotificaSiniestro?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>
                </Row>
                ) : null }
                <Row>
                  <Col>
                    <Form.Label className='mb-2 mt-4' style={{ fontWeight: 'bold', fontSize: '16px' }}>
                      {cfg_form28.cfg_form28['reasignaresponsable-input-obs']}
                    </Form.Label>{' '}
                    <br />
                    <Form.Control
                        as='textarea'
                        className='mb-2'
                        rows={2}
                        onChange={(e) => {
                          formik.handleChange(e)
                          setObservacion(e.target.value)
                        }}
                        name='observacion'
                        value={
                          (formik.values.observacion = observacion)
                        }
                        error={formik.errors.observacion}
                      />
                  </Col>
                </Row>
              </Container>
            </Container>
            <Container>
              <Row>
                <Col> 
                {respuestaAsignar && 
                  <Mensajes
                      showToast={showToast}
                      handleCloseToast={handleCloseToast}
                      delay={5000}
                      responseData={respuestaAsignar?.respuestaAsignar}
                  ></Mensajes>
                } 
                </Col>
                <Col className='d-flex align-items-end justify-content-end m-2'>
                  <Button className='m-2 w-auto' variant='outline-info' onClick={()=>setNoReasigna(true)}>
                    {cfg_form28.cfg_form28['reasignaresponsable-btn-cancelar']}                                          
                  </Button>
                  <Button className='m-2 ' variant='confirmar' type="onSubmit">
                    {cfg_form28 && cfg_form28.cfg_form28["reasignaresponsable-btn-confirmar"]}
                  </Button>
                </Col>
              </Row>
            </Container>
          </Card>
        </Container>
        </>

      )}
    </>
  )
}

export default Grilla
